import CloudArrowUpIcon from '@atlaskit/icon/core/cloud-arrow-up';
import * as React from 'react';

export function SvgImport() {
  return <CloudArrowUpIcon label="" testId="ads-refreshed-icon" />;
}
